import classNames from 'classnames'
import React, { useState } from 'react'
import { cloudflareImageLoader } from '../image/cloudflare-loader'
import { getRelativeProductImageUrl } from '../utils/urls'

type Props = {
  imageId: string
  slugText: string
  index: number
  isSelected: boolean
  numberOfImages: number
  select: () => void
}

const SliderButton = ({ imageId, slugText, index, isSelected, numberOfImages, select }: Props) => {
  const url = getRelativeProductImageUrl(imageId, 60, 50, slugText)

  const [isPressed, setIsPressed] = useState<boolean>(false)

  const imageUrl = cloudflareImageLoader({
    src: url,
    width: 60,
  })
  const buttonStyle: React.CSSProperties = {
    backgroundImage: `url(${imageUrl})`,
  }

  return (
    <button
      type="button"
      className={classNames('c-imageslider__thumb', {
        // first: index === 0,
        'c-imageslider__thumb--selected': isSelected,
      })}
      style={buttonStyle}
      aria-label={`Slide to image ${index + 1} of ${numberOfImages}`}
      aria-pressed={isPressed}
      onClick={e => {
        e.preventDefault()
        setIsPressed(!isPressed)
        select()
      }}
      onKeyDown={e => {
        if (e.key === 'Enter') {
          e.preventDefault()
          setIsPressed(!isPressed)
          select()
        }
      }}
    />
  )
}

export default SliderButton
